import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { isChildOfType } from "../_util/is-child-of-type";
import { useConfig } from "../_util/config-context";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var BreadcrumbItem = forwardRef(function BreadcrumbItem(_a, ref) {
    var current = _a.current, children = _a.children, className = _a.className, props = __rest(_a, ["current", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    if (typeof children === "string") {
        // eslint-disable-next-line no-param-reassign
        children = React.createElement("span", null, children);
    }
    return (React.createElement("li", __assign({ ref: ref, className: classNames(classPrefix + "-breadcrumb__item", className) }, props), React.isValidElement(children)
        ? React.cloneElement(children, {
            className: classNames(children.props.className, classPrefix + "-breadcrumb__item-title", {
                "is-current": current,
            }),
        })
        : children));
});
BreadcrumbItem.displayName = "BreadcrumbItem";
export var Breadcrumb = forwardRefWithStatics(function Breadcrumb(_a, ref) {
    var _b;
    var large = _a.large, children = _a.children, className = _a.className, props = __rest(_a, ["large", "children", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("ol", __assign({ ref: ref, className: classNames(classPrefix + "-breadcrumb", className, (_b = {},
            _b[classPrefix + "-breadcrumb--fz-large"] = large,
            _b)) }, props), React.Children.map(children, function (child, index) {
        if (isChildOfType(child, BreadcrumbItem) &&
            index === React.Children.count(children) - 1) {
            return React.cloneElement(child, {
                current: true,
            });
        }
        return child;
    })));
}, {
    Item: BreadcrumbItem,
});
Breadcrumb.displayName = "Breadcrumb";
//# sourceMappingURL=Breadcrumb.js.map